import { Box } from '@material-ui/core';

import { useCustomTheme } from '@/hooks/useCustomTheme';

import { useCheckResult } from '../hooks/useCheckResult';

export const CheckResultIcon = ({
  passed,
  boxProps,
}: {
  passed?: boolean;
  boxProps?: React.ComponentProps<typeof Box>;
}) => {
  const { palette } = useCustomTheme();

  const { checkResultParams } = useCheckResult(passed);

  return (
    <Box
      className={'check'}
      bgcolor={passed ? palette.success.main : palette.error.main}
      borderColor={'transparent'}
      {...boxProps}
    >
      {
        <i className={'material-icons-outlined'} style={{ color: checkResultParams.contrastText }}>
          {checkResultParams.iconName}
        </i>
      }
    </Box>
  );
};
